import * as React from 'react';
import EmbeddedPowerBIReport from '../../../../components/Reporting';
import LumenLoader from '../../../Loader';
import { useEffect } from 'react';

interface RenewalsChartProps {
    productLineCode?: string;
}

const RenewalsChart: React.FunctionComponent<RenewalsChartProps> = (props) => {
    const { productLineCode } = props;
    const PRODUCTION_BOUND_POLICIES_ID = 'bede9c57-0738-44f7-8e0e-7567b0bf8a07';
    const PRODUCTION_BOUND_POLICIES_WORKSPACE_ID = '5969b83e-5d39-4154-ad43-a016b71cd9e0';
    const PRODUCTION_BOUND_POLICIES_PAGENAME = 'b3ee88b78393a1c56a3d';

    const [delaying, setDelaying] = React.useState(false);

    useEffect(() => {
        if (delaying) {
            setTimeout(() => {
                setDelaying(false);
            }, 8500);
        }
    }, []);

    if (delaying) {
        return <LumenLoader fillHeight={'100%'} />;
    }
    return (
        <>
            <EmbeddedPowerBIReport
                reportId={PRODUCTION_BOUND_POLICIES_ID}
                workspaceId={PRODUCTION_BOUND_POLICIES_WORKSPACE_ID}
                height={'100%'}
                hidePageNav
                hideFilters
                pageName={PRODUCTION_BOUND_POLICIES_PAGENAME}
                hideReportBorder
                filter={{
                    table: 'POLICY_DIM',
                    column: 'PRODUCT_LINE_TYPE_CODE',
                    filter: [productLineCode || 'COMMERCIAL_PROPERTY'],
                }}
            />
        </>
    );
};

export default RenewalsChart;
